import React from 'react';
import { BaseLevelLayoutComponent } from '../level.components';
import BaseLevel from './base.levels';
import numberUtils from './utils/number.utils';
import numberBridgeUtils from './utils/numberBridge.utils';


export default class NumberBridgeLevelComponent extends BaseLevel {
    onEnter = () => {
        const answerRequired = this.props.level.settings.answer_required
        const roundOption = this.props.level.settings.step_size
        const step = numberBridgeUtils.getStepSize(this.state.quantities.value_2, roundOption)
        let result = 0

        if (answerRequired === 'value_1') {
            result = this.state.quantities.value_1
        } else if (answerRequired === 'value_2') {
            result = this.state.quantities.value_2
        } else if (answerRequired === 'step_1') {
            result = step
        } else if (answerRequired === 'step_2') {
            result = Math.abs(this.state.quantities.value_2 - step)
        } else {
            result = this.state.operation === 'addition' ?
                +this.state.quantities.value_1 + this.state.quantities.value_2 :
                this.state.quantities.value_1 - this.state.quantities.value_2
        }

        if (+this.state.answer === +result) {
            this.setState({ wrongAnswer: false, answer: '?' })
            this.props.onRoundComplete()
            this.generateLevel()
            this.onRoundComplete()
        } else {
            this.setState({ wrongAnswer: true, answer: '?' })
            this.props.onRoundFail()
            this.onRoundFail()
        }
    }
    render() {
        const level = this.props.level
        const stage = this.props.stage
        const settings = level.settings
        const quantities = this.state.quantities
        const answer = this.state.answer
        const wrongAnswer = this.state.wrongAnswer
        const gameContainerWidth = this.state.gameContainerWidth
        const gameContainerHeight = this.state.gameContainerHeight
        const numbersQuantities = { ...quantities }
        let operations = {}
        if (settings.sum_step) {
            const roundOption = settings.step_size || 1
            const step = numberBridgeUtils.getStepSize(quantities.value_2, roundOption)

            numbersQuantities.value_2 = step
            numbersQuantities.value_3 = quantities.value_2 - step

            if (settings.operation === 'addition') {
                if (+quantities.value_1 + +step > +quantities.value_1 + +quantities.value_2) {
                    operations = {
                        operation_1: '+',
                        operation_2: '-',
                    }
                } else {
                    operations = {
                        operation_1: '+',
                        operation_2: '+',
                    }
                }
            } else {
                if (+quantities.value_1 - step > +quantities.value_1 - quantities.value_2) {
                    operations = {
                        operation_1: '-',
                        operation_2: '-',
                    }
                } else {
                    operations = {
                        operation_1: '-',
                        operation_2: '+',
                    }
                }
            }
        }

        const answerString = settings.show_sum ? (settings.show_step && settings.sum_step ?
            numberUtils.getNumberBridgeString(settings, numbersQuantities, answer, operations):
            numberUtils.getNumberString(settings, quantities, answer)) : answer
        return (
            <BaseLevelLayoutComponent level={level} togglePause={this.props.togglePause} updateDimensions={this.updateDimensions} progress={this.props.progress || 0} stage={stage} answer={answerString} showSum={settings.show_sum} wrongAnswer={wrongAnswer} userBot={this.props.userBot} onRefresh={this.onRefresh} score={this.props.score} flash={this.state.flash} instruction={level.instruction} onExit={this.props.onExit} onUpdate={this.onUpdate} onEnter={this.onEnter} >
                <div ref="level" className='level'>
                    {gameContainerHeight > 0 && numberBridgeUtils.getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer)}
                </div>
            </BaseLevelLayoutComponent>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/game/levels/numberBridge.levels.js